<template>
  <div class="layout-vertical-center">
    <h1 class="text-center" style="font-size: var(--el-font-size-extra-large)">404 error</h1>
  </div>
</template>
